import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'guestAccessStatusColor' })
export class GuestAccessStatusColorPipe implements PipeTransform {

  private statusColors: string[] = ['#ed5565', '#23c6c8', '#f8ac59'];
  transform(value: any, args?: any): any {
    return this.statusColors[value];
  }

}
